import script from "./QueryPhotosView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryPhotosView.vue?vue&type=script&setup=true&lang=js"

import "./QueryPhotosView.vue?vue&type=style&index=0&id=05baa087&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05baa087"]])

export default __exports__